"use strict";

import {isset} from '../js-utilities';
import ManagerHelper from './helpers/manager-helper';
import {generateValueOutput} from "./helpers/calculator-helpers";

// A1c
export default class A1cManager {
    constructor(controller, language) {
        this.controller = controller;
        this.language = language;

        this.$a1cSummary = $('#a1c_summary');
        this.$a1cSummaryValue = $('#a1c_summary_value');

        this.$a1cOutputCellLabel = $('#a1c_output_cell_label');
        this.$a1cOutputCellValue = $('#a1c_output_cell_value');
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$a1cOutputCellIcon = $('#a1c_output_cell_icon');

        this.a1cHelper = new ManagerHelper('a1c', this.controller, this.updateA1cAgeInfluence.bind(this));
    }

    reconfigureA1cInput() {
        if (this.a1cHelper) {
            this.a1cHelper.configureInput();
        }
    }

    callGenerateSliderGradients() {
        if (this.a1cHelper) {
            this.a1cHelper.callGenerateSliderGradient();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    updateA1cAgeInfluence(a1c = this.controller.current_values.a1c) {
        if (isset(a1c) && isset(this.controller.current_values.gender)) {
            const response = this.controller.calculator_4.ageChangeForValue('a1c', a1c, this.controller.current_values.fractional_age, this.controller.current_values.gender);
            this.populateA1cOutput(response);
        } else {
            this.populateA1cOutput();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    populateA1cOutput(response) {
        const a1cOutput = generateValueOutput('a1c', response, this.controller);

        this.controller.current_age_changes.a1c = a1cOutput.ageChange;
        this.controller.current_values.a1c_change = a1cOutput.ageChangeText

        this.$a1cSummary.html(a1cOutput.summary);
        this.$a1cSummaryValue.html(a1cOutput.summaryValue);

        this.$a1cOutputCellLabel.html(a1cOutput.outputCellLabel);
        this.$a1cOutputCellValue.html(a1cOutput.outputCellValue).css('color', a1cOutput.outputCellColor);
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$a1cOutputCellIcon.prop('src', a1cOutput.outputCellIcon);

        this.controller.calculate_vascular_age();
    }

    // public method for controller to enable and disable UI controls
    enableControls(enable) {
        this.a1cHelper.enableControls(enable);
    }

}
